export default __webpack_public_path__ + "static/media/cny-188-ms.ceda57d9.webp";